import { LegacyIIQApi } from '../legacy-iiq-api'

const formatResult = ({ data, errors }: { data: any; errors: any[] }) => ({
  ...data,
  errors,
})

export const createApiKey =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (body: Record<string, any>) =>
    api.post('/api-keys', body).then(formatResult)

export const getApiKeys =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (query: Record<string, any>) =>
    api.get('/api-keys', query).then(formatResult)

export const getApiKey =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (apiKeyId: string) =>
    api.get(`/api-keys/${apiKeyId}`).then(formatResult)

export const updateApiKey =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  ({ id, ...apiKey }: { id: string; apiKey: Record<string, any> }) =>
    api.patch(`/api-keys/${id}`, apiKey).then(formatResult)

export const deleteApiKey =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (apiKeyId: string) =>
    api.delete(`/api-keys/${apiKeyId}`).then(formatResult)
